import { useEffect, useState } from 'react';
import './Stats.css';

const statDefinitions = [
  { label: 'Projects', value: 70, suffix: '+' },
  { label: 'Client Satisfaction', value: 99, suffix: '%' },
  { label: 'Support', value: 24, suffix: '×7' },
  { label: 'Years Experience', value: 7, suffix: '+' },
];

export default function Stats() {
  const [counts, setCounts] = useState(statDefinitions.map(() => 0));

  useEffect(() => {
    const duration = 1600;
    const start = performance.now();

    function animate(now) {
      const progress = Math.min((now - start) / duration, 1);
      setCounts(
        statDefinitions.map((stat) => Math.round(stat.value * progress))
      );

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    }

    requestAnimationFrame(animate);
  }, []);

  return (
    <div className="stats-grid">
      {statDefinitions.map((stat, index) => (
        <div key={stat.label} className="stat-card">
          <div className="stat-value">
            {counts[index]}
            <span>{stat.suffix}</span>
          </div>
          <p>{stat.label}</p>
        </div>
      ))}
    </div>
  );
}
